import { EventEmitter, Injectable } from "@angular/core";
import { ModelDetails, Organisation, Project } from "../../common/organisation";
import { UserService } from "../../user/user.service";
import { BACKUP_API, ORGANISATION_API, RepositoryService } from "../../linq-utils/repository.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent, ConfirmDialogModel } from "../../ui-components/dialogs/confirm-dialog.component";

const COMPONENT = "Backup service"

@Injectable({
    providedIn: 'root'
  })  
export class BackupService {
    backupRestoredEvent = new EventEmitter<void>()

    constructor(private userService:UserService, private repoService:RepositoryService, private snackBar:MatSnackBar, private dialog:MatDialog) {
    }

    async deleteBackup(organisation:Organisation, modelKey:string, backupKey:string, projectKey:string) {
        await this.repoService.callSingleAPI(this.repoService.delete(BACKUP_API(organisation._key, modelKey, backupKey, projectKey) + ""), COMPONENT, "Delete backup", this.userService.getUser(), organisation)
        this.snackBar.open("Backup deleted", "close", {duration:5000});
    }

    async deleteAllBackups(organisation:Organisation) {
        await this.repoService.callSingleAPI(this.repoService.delete(ORGANISATION_API(organisation._key) + "/backups"), COMPONENT, "Delete all backups", this.userService.getUser(), organisation)
        this.snackBar.open("All model backups deleted", "close", {duration:5000});
    }

    async createBackup(organisation:Organisation, model:ModelDetails, project?:Project, description?:string) {
        await this.repoService.callSingleAPI(this.repoService.create(BACKUP_API(organisation._key, model._key, undefined, project && project._key) + "", {description}), COMPONENT, "Create backup", this.userService.getUser(), organisation)
        this.snackBar.open("Backup created", "close", {duration:5000});
    }

    async restoreBackup(organisation:Organisation, model:ModelDetails, backupKey?:string, project?:Project) {
        await this.repoService.callSingleAPI(this.repoService.getData(BACKUP_API(organisation._key, model._key, backupKey, project && project._key) + ""), COMPONENT, "Restore backup", this.userService.getUser(), organisation)
        this.snackBar.open("Backup restored", "close", {duration:5000});
    }
    
    async confirmRestoreBackup(organisation:Organisation, model:ModelDetails, project?:Project, backupKey?:string) {
        let message = `This will replace the existing model. Are you sure you want to restore this backup?`;
        const dialogData = new ConfirmDialogModel("Confirm Action", [message], "restore", false, "Yes", "No");

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: "400px",
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(async dialogResult => {
            if (dialogResult) {
                if (dialogResult.button === "Yes") {
                    await this.restoreBackup(organisation, model, backupKey, project)
                    this.backupRestoredEvent.emit()
                }
            }
        })
    }

    async createOrganisationBackup(organisation:Organisation, description:string) {
        await this.repoService.callSingleAPI(this.repoService.create(ORGANISATION_API(organisation._key) + "/backup", {description}), COMPONENT, "Create organisation backup", this.userService.getUser(), organisation)
        this.snackBar.open("Organisation backup created", "close", {duration:5000});
    }

    async deleteOrganisationBackup(organisation:Organisation) {
        await this.repoService.callSingleAPI(this.repoService.delete(ORGANISATION_API(organisation._key) + "/backup"), COMPONENT, "Delete organisation backup", this.userService.getUser(), organisation)
        this.snackBar.open("Organisation backup deleted", "close", {duration:5000});
    }

    async restoreOrganisationBackup(organisation:Organisation) {
        await this.repoService.callSingleAPI(this.repoService.getData(ORGANISATION_API(organisation._key) + "/backup/restore"), COMPONENT, "Restore organisation backup", this.userService.getUser(), organisation)
        this.snackBar.open("Organisation backup restored", "close", {duration:5000});
    }

    async getOrganisationBackupCount(organisation:Organisation) {
        return await this.repoService.callSingleAPI(this.repoService.getData(ORGANISATION_API(organisation._key) + "/backup"), COMPONENT, "Get organisation backup count", this.userService.getUser(), organisation)
    }
}